import React, { Component, Fragment, pureComponent } from 'react';
import { inject, observer } from 'mobx-react';

@inject('lineStore')
@observer
export default class Systems extends Component{

  handleSelect = e => {
    this.props.lineStore.basket.newSetSystemType(e.target.value);
  };

  render() {
    const { basketData } = this.props.lineStore.basket;
    return basketData.systemTypeAvailable.length > 0 ? (
      <div className="basket-row basket-type-data-cont">
        <div className="basket-system-cont clearfix">
          <div className="basket-system-select-cont">
            <select onChange={this.handleSelect}>
              {basketData.systemTypeAvailable.map(el => (
                <option value={el.type} key={el.type} selected={basketData.systemType === el.type}>
                  {el.name}
                </option>
              ))}
            </select>
          </div>
          <div className="basket-label" />
        </div>
      </div>
    ) : (
      ''
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/basket/systems.js